import jwtDecode from 'jwt-decode'
import { getToken } from '../../../../lib/storage'

function determineIsKids() {
  const tokenFromLocalStorage = getToken()

  const decoded = tokenFromLocalStorage && jwtDecode(tokenFromLocalStorage)

  const isKid = decoded ? decoded.isKid : false
  return isKid
}

export default determineIsKids
